import { useTranslation } from 'react-i18next';
import { useUserGeneratedContent } from '../../../../models/user-generated-contents/context';
import '../form.scss';
import { LexicalBodyEditor } from '../../../../components/lexical-rich-text-editor';

const BodyInput = () => {
  const {
    userGeneratedContent,
    isPersisting,
    updateUserGeneratedContentFormState,
  } = useUserGeneratedContent();
  const { t } = useTranslation();
  const onTextChange = (body: string) => {
    updateUserGeneratedContentFormState({ body });
  };

  return (
    <LexicalBodyEditor
      defaultValue={userGeneratedContent.body}
      onChange={onTextChange}
      disabled={isPersisting}
      placeholder={t('user_generated_content.field_body_placeholder')}
    />
  );
};

export default BodyInput;
